module.exports = __webpack_public_path__ + "static/AppleWallet-296cfbf38824b4b5830db9bafc43beb1.png";